import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ModalRoot } from "./component/modal/ModalRoot";

export default function AppRoot() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <>
      <Outlet />
      <ModalRoot />
    </>
  );
}
